// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3l-2";
export var blackBorderOnHover = "_3l-7";
export var cell = "_3l-6";
export var cellContainer = "_3l-3";
export var checked = "_3l-8";
export var disabled = "_3l-5";
export var featuredIconCellContainer = "_3l-9";
export var featuredIconTextContainer = "_3l-b";
export var featuredIconWrapper = "_3l-a";
export var noBorder = "_3l-c";
export var orangeSelectedRow = "_bh-3";
export var overflowableText = "_3l-0";
export var overflowableTextContainer = "_3l-1";
export var row = "_3k-0";
export var rowCheckboxCell = "_3l-4";
export var selectableTable = "_bh-2";